export default "__VITE_ASSET__1fd00a6b__"